import * as React from "react";
import { Alert, Grid } from "@mui/material";
import { useGetAllContractsQuery } from "../../../services/cclTokenedEnterpriseCoachingApi";
import ContractSearchDataGridPro from "./contractList";

interface ContractSearchTabPanelProps {
    isNwaAdmin: boolean | null;
    partnerId: string | null;
}

const ContractSearchTabPanel: React.FC<ContractSearchTabPanelProps> = (props) => {
    const { data: allContracts, isLoading } = useGetAllContractsQuery(null);

    return (
        <React.Fragment>
            <Grid
                container
                spacing={0}
                alignItems="stretch"
                sx={{ justify: "space-between", flexGrow: 1 }}
            >
                <Grid item sx={{ display: "flex", flexDirection: "column", width: 1, height: 1 }}>
                    <Alert sx={{m: 1}} severity="info">Contracts prior to 2021 are not unique per Coach and only one copy will be downloaded for contracts selected for those years.</Alert>
                    <ContractSearchDataGridPro loading={isLoading} contracts={allContracts ?? []} />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default ContractSearchTabPanel;
